import { Avatar, Select } from "@mantine/core";
import "dayjs/locale/tr";
import styled, { css } from "styled-components";
import { useState } from "react";

const CustomSelect = ({
  iconSrc = "/assets/multiSelectChevronDown.png",
  w = 190,
  clearable = false,
  searchable = false,
  withAsterisk = false,
  rightSection,
  h = 32,
  ...rest
}: any) => {
  const [dropdownOpened, setDropdownOpened] = useState(false);

  return (
    <StyledSelect
      w={w}
      $height={h}
      /*
       * DÜZ BOOLEAN. Eskiden `{`${clearable}`}` ile stringe çevriliyordu; Mantine
       * `Select` bu prop'u destekliyor, yani çevirmeye gerek yoktu ve "false"
       * dizesi TRUTHY olduğu için `clearable={false}` isteyen çağrı yine
       * temizleme düğmesi görüyordu (ör. RotationBoard'daki rota seçici).
       */
      clearable={clearable}
      withAsterisk={withAsterisk}
      searchable={searchable}
      leftSectionPointerEvents="none"
      onDropdownOpen={() => setDropdownOpened(true)}
      onDropdownClose={() => setDropdownOpened(false)}
      rightSection={
        rightSection ?? (
          <RotatingWrapper $isOpen={dropdownOpened}>
            <Avatar
              radius={0}
              src={iconSrc}
              size={20}
              style={{ cursor: "pointer" }}
            />
          </RotatingWrapper>
        )
      }
      {...rest}
    />
  );
};

export default CustomSelect;

const StyledSelect = styled(Select)<{ $height?: number | string }>`
  .mantine-Select-input {
    height: ${({ $height }) => `${$height}px`};
  }
`;

const RotatingWrapper = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;
